<template>
  <div style="width: 100%">
    <wiki-home-top />
    <fixed-share from="detail" :detail="detail" />
    <div
      v-loading.fullscreen.lock="loading"
      :class="[classBase + 'wiki-detail', `detail-${device.orientation}`]"
      class="wiki-detail"
    >
      <div class="wiki-main-box">
        <div class="wiki-detail-box">
          <!--          // 文章审核中，展示审核提示-->
          <template v-if="detail.isUnderReview && detail.isUnderReview === 1">
            <detail-review />
          </template>
          <template v-else-if="detail.audit_state === -1">
            <detail-disabled :detail="detail"></detail-disabled>
          </template>
          <template v-else>
            <!-- 返回按钮 -->
            <div v-if="hasHistory" class="back-item" @click="goBack()">
              <i class="el-icon-arrow-left"></i>
            </div>

            <div class="main-content">
              <div class="wiki-detail-body">
                <!-- 文章标题 -->
                <detail-title :detail="detail"></detail-title>
                <!-- 文章描述 -->
                <detail-desc :detail="detail" @refresh="refresh"></detail-desc>

                <!-- 贡献者 -->
                <detail-contributor :detail="detail"></detail-contributor>
                <!-- 正文内容 -->
                <template v-if="detail && detail.id > 0">
                  <!-- 老编辑器 -->
                  <detail-content v-if="detail.editor_type == 0" :content-data="detail" />
                  <!-- 新编辑器 -->
                  <detail-json-content v-if="detail.editor_type == 1" :content-data="detail" />
                  <!-- 图鉴编辑器 -->
                  <book-content
                    v-else-if="detail.editor_type == 2"
                    mode="view"
                    :content-data="formatContentData(detail.content_json)"
                  />
                </template>

                <!-- 正文创建日期、举报、点赞、收藏 -->
                <detail-footer :detail="detail" @refresh="refresh"></detail-footer>
              </div>
              <!-- 添加评论\评论列表 -->
              <detail-comment
                :detail="detail"
                :user="user"
                :list="list"
                :pagination="pagination"
                :loadCommentStatus="loadCommentStatus"
                @getCommentList="getCommentList"
                @refresh="refresh"
                @setLoading="setLoading"
              ></detail-comment>
            </div>
            <!-- 相关推荐、目录 -->
            <wiki-cata-log from="detail" :recommendList="recommendList">
              <!-- aticle用户 -->
              <detail-user slot="top" :detail="detail" :user="user" @refresh="refresh"></detail-user>
            </wiki-cata-log>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// plugins
import eventBus from "@/plugins/eventBus";
import { getJumpWikiDetailUrl } from "@/plugins/util";
// components
import WikiHomeTop from "@/layout/wiki/components/wikiHomeTop";
import WikiCataLog from "@/views/wiki/components/wikiCataLog";
import FixedShare from "@/layout/wiki/components/fixedShare";

import DetailTitle from "./components/detailTitle";
import DetailDesc from "./components/detailDesc";
import DetailUser from "./components/detailUser";
import DetailContributor from "./components/detailContributor";
import DetailContent from "./components/detailContent";
import DetailJsonContent from "./components/detailJsonContent";
import DetailFooter from "./components/detailFooter";
import DetailComment from "./components/detailComment";
import BookContent from "../illustrated-book/BookContent";
import DetailReview from "./components/detailReview";
import DetailDisabled from "./components/detailDisabled";
// api
import { apiContentDetail, apiGetRecommend, apiVersionDetail } from "@/api/contentApi";
import { apiCommentList } from "@/api/commentApi";
// mixins
import mergeAsyncDataMixin from "@/mixins/mergeAsyncDataMixin";

export default {
  name: "detail",
  mixins: [mergeAsyncDataMixin],
  props: {},
  model: {},
  components: {
    WikiHomeTop,
    WikiCataLog,
    FixedShare,

    DetailTitle,
    DetailDesc,
    DetailUser,
    DetailContributor,
    DetailContent,
    DetailJsonContent,
    DetailFooter,
    DetailComment,
    BookContent,
    DetailReview,
    DetailDisabled
  },
  data() {
    return {
      loading: false,
      prevRoute: null,
      hasHistory: true,

      // 详情
      isSSRGetData: false,
      detail: {
        user: { uid: 0 }
      },
      user: {
        avatar: "",
        uid: 0,
        username: "",
        is_followed: 0
      },
      // 评论列表
      list: [],
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      loadCommentStatus: "",
      // 相关推荐
      recommendList: []
    };
  },
  async asyncData({ router, store, ssrContext, $apis }) {
    try {
      console.log("asyncData start");
      const route = router.currentRoute;
      const routeMeta = route.meta;
      // 数据预取
      const gameInfo = store.getters.gameInfo;
      let { params } = router.currentRoute;
      let detail = {
        user: { uid: 0 }
      };
      let user = {
        avatar: "",
        uid: 0,
        username: "",
        is_followed: 0
      };
      let list = [];
      let recommendList = [];
      let pagination = {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      };

      if (params.id.includes("_")) {
        let ids = params.id.split("_");
        const { code, data } = await $apis.apiVersionDetail({
          id: ids[1]
        });
        if (code == 0) {
          detail = data;
          user = detail.user;
        }
      } else {
        const res = await Promise.all([
          // 详情
          $apis.apiContentDetail({
            id: params.id
          }),
          // 评论
          $apis.apiCommentList({
            ...pagination,
            content_id: Number(params.id)
          }),
          // 推荐
          $apis.apiGetRecommend({
            id: params.id,
            limit: 10,
            get_adv: true
          })
        ]);
        // 详情
        const { code: detailResCode, data: detailResData } = res[0];
        if (detailResCode == 0) {
          detail = detailResData;
          user = detail.user;
          // 文章关联wiki和当前wiki不匹配，返回对应wiki详情；
          if (!routeMeta.noWikiRoute && detail.game.alias != gameInfo.alias) {
            const url = getJumpWikiDetailUrl(detail.game.alias, detail.game.id, params.id);
            ssrContext.redirectURL = url;
            return;
          }
        }
        // 评论
        const { code: commentResCode, data: commentResData, meta: commentResMeta } = res[1];
        if (commentResCode == 0) {
          list = commentResData || [];
          pagination = commentResMeta.pagination;
        }
        // 推荐内容
        const { code: recommendResCode, data: recommendResData } = res[2];
        if (recommendResCode == 0) {
          recommendList = recommendResData || [];
        }
      }

      // TDK设置
      if (detail) {
        const isWww = store.getters.isWww;
        if (isWww) {
          ssrContext.title = detail.title + "|Gamekee";
        } else {
          ssrContext.title = `${detail.game.name}${detail.title}_${detail.game.name}wiki|GameKee`;
          // 判断是否新图鉴
          if (detail.editor_type == 2) {
            ssrContext.keywords = detail.title;
          } else {
            ssrContext.keywords = "";
          }
          ssrContext.description = detail.summary;
        }
        // console.log(detail.seo);
        // 自定义编辑的TDK
        if (detail.seo && detail.seo_format) {
          const seo = detail.seo_format;
          if (seo.title) {
            ssrContext.title = seo.title;
          }
          if (seo.key) {
            ssrContext.keywords = seo.key;
          }
          if (seo.desc) {
            ssrContext.description = seo.desc;
          }
        }
      }

      console.log("asyncData end");
      return {
        detail,
        user,
        recommendList,
        list,
        pagination,
        isSSRGetData: true
      };
    } catch (err) {
      console.log(err);

      let detail = {
        user: { uid: 0 }
      };
      if (err && err.code == 1002 && err.msg == "文章不存在: record not found") {
        // 没有文章信息，重定向到404
        ssrContext.redirectURL = "/404";
      } else if (err && err.code === 100002) {
        // 文章审核中，展示审核提示
        detail = {
          isUnderReview: 1
        };
      } else if (err && err.code === 100010) {
        // 文章被禁用
        detail = {
          audit_state: -1
        };
      }
      return {
        detail,
        isSSRGetData: true
      };
    }
  },
  computed: {
    ...mapGetters(["loginUser", "loginUid", "gameInfo", "device"])
  },

  beforeRouteEnter(to, form, next) {
    // 把上一页路由信息存到当前页面
    next(vm => {
      vm.prevRoute = form;
    });
  },
  watch: {
    $route: "init"
  },
  created() {
    // this.init();
  },
  beforeMount() {
    // 服务端已获取数据
    if (!this.isSSRGetData) {
      this.init();
    }
  },
  async mounted() {
    await this.$nextTick();
    if (history.length > 1) {
      this.hasHistory = true;
    } else {
      this.hasHistory = false;
    }
    // if (!this.isHeroGame && this.device.height > 600) {
    //   (adsbygoogle = window.adsbygoogle || []).push({});
    // }
  },
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 返回
    goBack() {
      window.history.back();
      // 将服务端数据置空，防止动态切换默认渲染此数据
      this.$store.commit("set_ssr_component_data", []);
    },
    // 设置loading
    setLoading(loading) {
      this.loading = loading;
    },
    // 刷新详情
    refresh(detail, user) {
      if (detail) {
        this.$set(this, "detail", detail);
      }
      if (user) {
        this.$set(this, "user", user);
      }
    },
    // 格式化图鉴数据
    formatContentData(content_json) {
      const contentJson = JSON.parse(content_json);
      if (Array.isArray(contentJson)) {
        return contentJson;
      }
      return contentJson.children;
    },
    // 获取文章详情
    async getDetail() {
      let { params } = this.$route;
      let id = params.id.split("_")[0];
      // this.detail = { user: { uid: 0 } };
      // return;
      await apiContentDetail({ id })
        .then(async res => {
          if (res.code == 0) {
            this.detail = res.data;
            const routeMeta = this.$route.meta;
            // 文章关联weiki和当前wiki不匹配，返回对应wiki详情；
            if (!routeMeta.noWikiRoute && this.detail.game.alias != this.gameInfo.alias) {
              const url = getJumpWikiDetailUrl(this.detail.game.alias, this.detail.game.id, id);
              window.location.replace(url);
              return;
            }
            this.user = this.detail.user;
            // eventBus.$emit('setDetailContent', res.data);
            await this.getCommentList();
          }
        })
        .catch(err => {
          // 文章审核中
          if (err && err.code === 100002) {
            this.detail = {
              isUnderReview: 1
            };
            return;
          }
          // 文章禁用
          if (err && err.code === 100010) {
            this.detail = {
              audit_state: -1
            };
            return;
          }
          if (err && err.code == 1002 && err.msg == "文章不存在: record not found") {
            // 没有文章信息，重定向到404
            this.$router.replace("/404");
          }
        });
    },
    // 获取推荐
    getRecommend() {
      let { params } = this.$route;
      let id = params.id.split("_")[0];
      let param = {
        id,
        limit: 10,
        get_adv: true
      };
      apiGetRecommend(param).then(res => {
        if (res.code === 0) {
          this.recommendList = res.data || [];
        }
      });
    },
    // 获取历史记录详情
    async getLogDetail() {
      let { params } = this.$route;
      // console.log(params.id.split("_"));
      let id = params.id.split("_")[1];

      await apiVersionDetail({ id })
        .then(async res => {
          this.detail = res.data;
          this.user = this.detail.user;
          eventBus.$emit("setDetailContent", res.data);
        })
        .catch(err => {
          // 文章审核中
          if (err && err.code === 100002) {
            this.detail = {
              isUnderReview: 1
            };
          }
        });
    },
    // 获取评论
    async getCommentList(type) {
      if (this.$route.params.id.includes("_")) return;
      if (type == "refresh") {
        this.pagination = {
          limit: 10,
          page_no: 0,
          page_total: 1,
          total: 0
        };
        this.list = [];
      }
      let { pagination } = this;
      if (pagination.page_no >= pagination.page_total) {
        this.loadCommentStatus = "end";
        return;
      }
      let { id } = this.$route.params;
      ++pagination.page_no;
      let params = {
        ...pagination,
        content_id: Number(id)
      };
      this.loadCommentStatus = "loading";
      await apiCommentList(params)
        .then(res => {
          if (res.code == 0) {
            this.list = this.list.concat(res.data);
            this.pagination = res.meta.pagination;
            // if (this.list.length > 2 && this.pagination.page_no == 1) {
            // }
          }
        })
        .finally(_ => {
          this.loadCommentStatus = "";
        });
    },
    // 初始化
    async init() {
      let { params } = this.$route;
      this.logList = [];
      this.logPagination = {
        limit: 10,
        page_no: 1,
        page_total: 1,
        total: 0
      };
      if (params.id.includes("_")) {
        await this.getLogDetail();
      } else {
        await this.getDetail();
      }
      this.getRecommend();
    }
  }
};
</script>

<style lang="less" scoped>
.wiki-detail {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .wiki-main-box {
    position: relative;
    width: 100%;
    margin-top: 12px;
    padding: 12px;
    border-radius: 12px;
    box-sizing: border-box;
    background: rgba(26, 62, 97, 0.1);
  }
}

.wiki-detail-box {
  position: relative;
  width: 100%;
  padding: 80px 72px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  min-height: 2500px;

  .main-content {
    width: calc(100% - 334px);
  }

  .back-item {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    background-color: #eee;
    cursor: pointer;
    line-height: 28px;
    text-align: center;
    color: #000;
    font-size: 18px;
    font-weight: bold;
  }

  .wiki-commend-list {
    margin-top: 12px;
  }
}

.wiki-detail-body {
  border-radius: 2px;
}

.pc-wiki-detail {
  .wiki-detail-body {
    margin-bottom: 54px;
  }
}
</style>
